import * as cmMessageErrorCodes from '../../consts/communicationLayer/cmMessageErrorCodes';
import * as cmMessageProperties from '../../consts/communicationLayer/cmMessageProperties';
import * as cmMessageTypes from '../../consts/communicationLayer/cmMessageTypes';
import connectivityService from '../device/connectivityService';
import deviceIdlePingService from '../device/deviceIdlePingService';
import framesProcessingService from '../device/framesProcessingService';
import cyclicFramesService from '../hid/cyclicFramesService';
import {scpUtils} from '../scp/scpUtils';
import cmMessageRequestService from './cmMessageRequestService';
import {getScpFrameRequestPriorityByCmPriorityLevel} from '../../consts/communicationLayer/cmPriorityLevelTypes';
import deviceCharacteristicService from '../ble/deviceCharacteristicService';

const onStatusCharacteristicHandler = (message) => {
    const isBle = connectivityService.isBle();

    if (isBle) {
        onStatusCharacteristicBleHandler(message);
    } else {
        onStatusCharacteristicUsbHandler(message);
    }
};

const onStatusCharacteristicBleHandler = (message) => {
    const {data} = message;
    const properties = [cmMessageProperties.SYSTEM_STATUS, cmMessageProperties.BATTERY_STATUS];

    properties.forEach((statusPropertyName) => {
        const propertyValue = data?.[statusPropertyName];
        const {subscribe: uuid} = propertyValue || {};

        if (!uuid) return;

        deviceCharacteristicService.subscribeToCharacteristic(statusPropertyName, uuid);
    });
};

const onStatusCharacteristicUsbHandler = (message) => {
    const {type, request_id, data} = message;
    const properties = [cmMessageProperties.SYSTEM_STATUS, cmMessageProperties.BATTERY_STATUS];

    properties.forEach((statusPropertyName) => {
        const propertyValue = data?.[statusPropertyName];
        const {iteration_delay, frame} = propertyValue || {};

        if (!frame || !iteration_delay) return;

        const props = {
            type,
            cyclicId: statusPropertyName,
            frames: [frame],
            request_id,
            cyclicTimeout: iteration_delay,
        };

        cyclicFramesService.writeFrameCyclic(props);
    });
};

const onCycleRequestHandler = (message) => {
    const {type, token, request_id, data} = message;
    const {iteration_delay, cycle_frame, max_iterations} = data || {};

    if (!cycle_frame || !iteration_delay) return;

    const props = {
        token,
        type,
        cyclicId: cmMessageProperties.CYCLE_FRAME,
        frames: [cycle_frame],
        request_id,
        cyclicTimeout: iteration_delay,
        maxIterations: max_iterations,
        isResponseCheckNeeded: true,
    };

    cyclicFramesService.writeFrameCyclic(props);
};

const defaultHandler = (message, isHolder) => {
    const {type, token, request_id, frames, data, conditional_frames, priority_level} = message;

    if (!frames?.length && !conditional_frames) return;

    const onWriteFramesError = (isDeviceDisconnect) => {
        if (!isHolder && isDeviceDisconnect && type === cmMessageTypes.RESET) {
            cmMessageRequestService.publishSuccessReset({request_id, token});
            return;
        }

        cmMessageRequestService.publishErrorEvent({
            type,
            request_id,
            token,
            errorCode: isDeviceDisconnect ? cmMessageErrorCodes.DEVICE_DISCONNECTED : cmMessageErrorCodes.UNKNOWN_ERROR,
            isHolder,
        });
        deviceIdlePingService.pingDeviceIfNeeded();
    };
    const writeFrames = ({frames, framesNodeName = 'frames'}) => {
        framesProcessingService.writeFrameAndPublishResponse({
            frames,
            skipErrorOnTimeout: type === cmMessageTypes.DEVICE_USAGE_DATA_CAPABILITIES,
            onSuccess: (...frames) => {
                cmMessageRequestService.publishResponseEvent({
                    type,
                    request_id,
                    token,
                    isHolder,
                    data,
                    [framesNodeName]: frames,
                });
            },
            onError: onWriteFramesError,
            priority: getScpFrameRequestPriorityByCmPriorityLevel(priority_level),
            requestId: request_id,
        });
    };

    if (conditional_frames) {
        const {initial_frame} = conditional_frames;

        framesProcessingService.writeFrameAndPublishResponse({
            frames: [initial_frame],
            onSuccess: (frame) => {
                const {
                    mask_check: {offset, mask},
                    if_no_match_frames,
                    if_match_frames,
                } = conditional_frames;
                const maskParsed = parseInt(mask);
                const doesFrameMatchMask = scpUtils.doesFrameMatchMask({frame, offset, mask: maskParsed});
                const writeFramesProps = doesFrameMatchMask
                    ? {frames: if_match_frames, framesNodeName: 'match_frames'}
                    : {frames: if_no_match_frames, framesNodeName: 'no_match_frames'};

                writeFrames(writeFramesProps);
            },
            onError: onWriteFramesError,
        });

        return;
    }

    /*if (type === cmMessageTypes.SOFTWARE_IDENTIFICATION || type === cmMessageTypes.SBL_IDENTIFICATION) {
        const state = getState();
        const isOfflineMode = makeSelectIsOfflineYapFirmwareInProgress()(state);

        if (isOfflineMode) return;

        const isReady = await cmService.waitUntilConnected({
            isHolder,
            isCheckDeviceReady: true,
            timer: getFwuReconnectTimeout(),
        });

        if (!isReady) {
            const fwu_target = getFwuTargetFromMessage(message, isHolder);

            onFwuError({errorCode: cmMessageErrorCodes.DEVICE_DISCONNECTED, fwu_target}, message, isHolder);
            return;
        }
    }*/

    writeFrames({frames});
};

const onCancelRequestHandler = (message, isHolder) => {
    const {type, token, request_id, data} = message;
    const {cancel_request_id} = data || {};

    if (!cancel_request_id) return;

    const onCancel = (success) => {
        cmMessageRequestService.publishResponseEvent({
            type,
            request_id,
            token,
            isHolder,
            data: {
                success,
            },
        });
    };

    framesProcessingService.cancelRequest({requestId: cancel_request_id, onCancel});
};

export default {
    onStatusCharacteristicHandler,
    onCycleRequestHandler,
    defaultHandler,
    onCancelRequestHandler,
};
